import Mutations from '../../odata/mutations';

export default { ...new Mutations('dimension'), ...new Mutations('dimensions') };
